/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions, FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsFirebase.js.map